module.exports = __webpack_public_path__ + "static/media/success.da188ccb.png";